<template>
  <div class="wrap">
    <div v-show="!showVisitingDetail" style="position: relative">
      <div style="margin-bottom: 10px;display: flex;align-items: center">
        <el-input clearable @change="searchHandler" v-model="inHosSearch.departmentName" size="mini"
          style="width: 150px;margin-right: 5px" type="text" placeholder="科室"></el-input>
        <el-date-picker @change="searchHandler" style="width: 250px;margin-right: 5px;" size="mini"
          v-model="inHosSearch.visitingDate" type="datetimerange" range-separator="至"
          :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-select placeholder="就诊" style="margin-right: 5px;width: 150px;" @change="searchHandler" clearable size="mini"
          v-model="inHosSearch.visitingType">
          <el-option label="门诊" value="0"></el-option>
          <el-option label="住院" value="1"></el-option>
          <el-option label="体检" value="2"></el-option>
        </el-select>
        <el-select placeholder="检查" style="width: 150px;" @change="searchHandler" clearable size="mini"
          v-model="inHosSearch.isRecording">
          <el-option label="有" value="1"></el-option>
          <el-option label="无" value="2"></el-option>
        </el-select>
      </div>
      <el-table :data="patientMedicalRecord" border style="width: 100%">
        <el-table-column prop="departmentName" label="就诊科室">
        </el-table-column>
        <el-table-column prop="visitingDate" label="就诊时间">
        </el-table-column>
        <el-table-column prop="visitingType" label="就诊类别">
        </el-table-column>
        <el-table-column prop="isContain" label="检查" width="50">
        </el-table-column>
        <el-table-column label="操作">
          <div slot-scope="scope">
            <span :class="{ 'tableBtn': true, 'active': scope.row.id == currentInHosInfo.id }"
              @click="getVisitingNoMedicalRecordDetail(scope.row)">详情</span>
          </div>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="inHosPageChangeHandler" background :page-size="1" :current-page="currentInhosPage"
        layout="prev, pager, next" :total="inHosTotalPage">
      </el-pagination>
    </div>
    <div v-show="showVisitingDetail">
      <div v-show="!showReportDetail">
        <div style="text-align: left;margin-bottom: 10px;">
          <el-button size="mini" type="primary" @click="showVisitingDetail = false">返回</el-button>
        </div>
        <el-descriptions class="margin-top" title="" :column="1" :size="'small'" border>
          <el-descriptions-item label="就诊医院">{{ visitingNoMedicalRecordDetail.hospitalName }}</el-descriptions-item>
          <el-descriptions-item label="就诊科室">{{
            visitingNoMedicalRecordDetail.departmentName
          }}
          </el-descriptions-item>
          <el-descriptions-item label="主诊医生">{{
            visitingNoMedicalRecordDetail.primaryPhysicianName
          }}
          </el-descriptions-item>
          <el-descriptions-item label="诊断">{{ visitingNoMedicalRecordDetail.diagnosisName }}</el-descriptions-item>
          <el-descriptions-item label="检查报告" v-if="visitingNoMedicalRecordDetail.reports">
            <span @click="getInspectionReportDetailed(it)"
              style="margin-right:10px;margin-bottom: 10px;display: inline-block;background-color: #248cfa;cursor:pointer;padding: 5px;color: #fff"
              v-for="(it, ind) in visitingNoMedicalRecordDetail.reports" :key="ind">{{ it.reportName }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="出院时间" v-if="visitingNoMedicalRecordDetail.reports">
            <span @click="getPatientDischargeRecord(visitingNoMedicalRecordDetail)"
              style="margin-right:10px;margin-bottom: 10px;display: inline-block;background-color: #248cfa;cursor:pointer;padding: 5px;color: #fff"
              v-if="visitingNoMedicalRecordDetail.dischargeTime">{{ visitingNoMedicalRecordDetail.dischargeTime }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="入院时间" v-if="visitingNoMedicalRecordDetail.reports">
            <span @click="getPatientAdmissionRecord(visitingNoMedicalRecordDetail)"
              style="margin-right:10px;margin-bottom: 10px;display: inline-block;background-color: #248cfa;cursor:pointer;padding: 5px;color: #fff"
              v-if="visitingNoMedicalRecordDetail.admissionTime">{{ visitingNoMedicalRecordDetail.admissionTime }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="手术报告">
            <span @click="getPatientSurgeryRecord(visitingNoMedicalRecordDetail)"
              style="margin-right:10px;margin-bottom: 10px;display: inline-block;background-color: #248cfa;cursor:pointer;padding: 5px;color: #fff"
              v-if="visitingNoMedicalRecordDetail.operationRecord">有</span>
          </el-descriptions-item>
          <el-descriptions-item label="手术时间">
                        <span @click="getPatientSurgeryTime(visitingNoMedicalRecordDetail)" style="margin-right:10px;margin-bottom: 10px;display: inline-block;background-color: #248cfa;cursor:pointer;padding: 5px;color: #fff" v-if="visitingNoMedicalRecordDetail.surgeryTime">{{ visitingNoMedicalRecordDetail.surgeryTime}}{{  }}</span>
                      </el-descriptions-item>
        </el-descriptions>

      </div>
      <div v-show="showReportDetail">
        <div style="text-align: left;margin-bottom: 10px;">
          <el-button size="mini" type="primary" @click="showReportDetail = false">返回</el-button>
        </div>
        <div class="trans_box" v-if="inspectionReportDetailed.reportType == 1">
          <ul class="trans_header">
            <table>
              <tr class="report-basc">
                <td><span>姓名：</span><span>{{ inspectionReportDetailed.userName }}</span></td>
                <td style="width: 25%;"><span>性别：</span><span>{{ sexType(inspectionReportDetailed.userSex) }}</span>
                </td>
                <td><span>年龄：</span><span>{{ inspectionReportDetailed.age }}</span></td>
              </tr>
              <tr>
                <td><span>病历号：</span><span>{{ inspectionReportDetailed.admitNo }}</span></td>
                <td><span>床号：</span><span>{{ inspectionReportDetailed.bed }}</span></td>
                <td><span>病区：</span><span>{{ inspectionReportDetailed.wardName }}</span></td>
              </tr>
              <tr v-show="inspectionReportDetailed.bed">
                <td><span>科室：</span><span>{{ inspectionReportDetailed.departmentName }}</span></td>
              </tr>
            </table>
            <div class="report-other">
              <li><span>标本种类：</span><span>{{ inspectionReportDetailed.specimenName }}</span></li>
              <li><span>采样时间：</span><span>{{ inspectionReportDetailed.collectDate }}</span></li>
              <li><span>申请时间：</span><span>{{ inspectionReportDetailed.applicantDate }}</span></li>
            </div>
            <table class="trans_body_header">
              <tr style="display: flex;">
                <td class="bodyNo">序号</td>
                <td class="bodyItem">项目</td>
                <td class="bodyResult">结果</td>
                <td class="bodyRela">参考值</td>
                <td class="bodyUnit">单位</td>
              </tr>
            </table>
          </ul>
          <div class="trans_body" id="trans_body">
            <tr v-for="(item, index) in inspectionReportDetailed.labIndexs " :key="index" class="animate">
              <td class="bodyNo">{{ index + 1 }}</td>
              <td class="bodyItem">{{ item.labIndexName }}</td>
              <td :class="{ bodyResult: true, 'high': item.unusualPrompt == 'H', 'low': item.unusualPrompt == 'L' }">
                {{ item.labIndexResult }}
                <i v-if="item.unusualPrompt == 'H'" style="font-style: normal;font-weight: 700;color: red;">↑</i>
                <i v-else-if="item.unusualPrompt == 'L'" style="font-style: normal;font-weight: 700;color: #248cfa;">↓</i>
              </td>
              <td class="bodyRela">{{ item.referenceRange }}</td>
              <td class="bodyUnit" style="text-align: center;">{{ item.unit }}</td>
            </tr>
            <section class="trans_bottom">
              <li><span>检验医师：</span><span>{{ inspectionReportDetailed.examinerName }}</span></li>
              <li><span>检验时间：</span><span>{{ inspectionReportDetailed.examineDate }}</span></li>
              <li><span>报告时间：</span><span>{{ inspectionReportDetailed.reportDate }}</span></li>
              <li><span>核对者：</span><span>{{ inspectionReportDetailed.verifierName }}</span></li>
              <li>*检验结果显示为文本*偏低&nbsp;正常&nbsp;偏高&nbsp;阳性&nbsp;其他</li>
            </section>
          </div>
        </div>
        <div class="trans_box_two" v-else-if="inspectionReportDetailed.reportType == 2">
          <ul class="trans_header">
            <table>
              <tr class="report-basc">
                <td><span>姓名：</span><span>{{ inspectionReportDetailed.userName }}</span></td>
                <td style="width: 25%;"><span>性别：</span><span>{{ sexType(inspectionReportDetailed.userSex) }}</span>
                </td>
                <td><span>年龄：</span><span>{{ inspectionReportDetailed.age }}</span></td>
              </tr>
              <tr>
                <td><span>病历号：</span><span>{{ inspectionReportDetailed.admitNo }}</span></td>
                <td><span>床号：</span><span>{{ inspectionReportDetailed.bed }}</span></td>
                <td><span>科室：</span><span v-show="inspectionReportDetailed.bed">{{ inspectionReportDetailed.departmentName
                }}</span></td>
              </tr>
              <tr>
                <td><span>病区：</span><span>{{ inspectionReportDetailed.wardName }}</span></td>
                <td></td>
                <td><span>{{ inspectionReportDetailed.imageNo }}</span></td>
              </tr>
            </table>
            <div class="report-other">
              <li><span>检查日期：</span><span>{{ inspectionReportDetailed.examineDate }}</span></li>
            </div>
          </ul>
          <!--<div class="trans_body">-->
          <section class="trans_text">
            <div style="margin-top: 10px;">
              <span>【检查方法和技术】</span><span>{{ inspectionReportDetailed.checkMethod || inspectionReportDetailed.checkName }}
              </span>
            </div>
            <div><span>【影像学表现】</span><span>{{ inspectionReportDetailed.findings }}</span></div>
            <div><span>【影像学诊断】</span><span>{{ inspectionReportDetailed.conclusions }}</span></div>
          </section>
          <section class="trans_bottom">
            <li><span>报告医师：</span><span></span></li>
            <li><span>影像医师：</span><span></span></li>
          </section>
          <!--</div>-->
        </div>
        <div v-else-if="inspectionReportDetailed.reportType == 3">
          <div v-html="inspectionReportDetailed.detail"></div>
        </div>
        <div class="inspectionReportDetailed" v-else-if="inspectionReportDetailed.reportType == 4">
          <div v-html="inspectionReportDetailed.detail"></div>
        </div>
        <div v-else-if="inspectionReportDetailed.reportType == 5">
                      <div v-for="(item,index) in inspectionReportDetailed.detail" :key="index">
                        <el-descriptions class="margin-top" title="" :column="1" :size="'small'" border>
                          <el-descriptions-item label="手术名称">{{ item.surgeryName }}</el-descriptions-item>
                          <el-descriptions-item label="申请手术时间">{{ item.inputTime }}</el-descriptions-item>
                          <el-descriptions-item label="计划手术时间">{{ item.applyTime }}</el-descriptions-item>
                          <el-descriptions-item label="手术开始时间">{{ item.surgeryTime }}</el-descriptions-item>
                          <el-descriptions-item label="手术结束时间">{{ item.surgeryEndTime }}</el-descriptions-item>
                        </el-descriptions>
                      </div>
                    </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import PatientInHospitalList from './patientInHospitalList.vue'
import PatientReportList from './patientReportList.vue'
import {
  RestFeedbackOutControllerGetPatientMedicalRecordNewList,
  RestCallCenterServiceGetCallPatientInspectionReportList,
  RestFeedbackOutControllerGetPatientMedicalRecordList,
  RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail,
  RestFeedbackOutControllerGetInspectionReportDetailed
} from "@src/assets/js/api.js";
import { mapState, mapGetters } from 'vuex';
import errorHandleMixin from "@mixins/errorHandleMixin";
import moment from 'moment'
export default {
  name: 'PatientInHospitalIndex',
  data() {
    return {
      inspectionReportDetailed: {},
      inHosSearch: {
        departmentName: "",
        visitingType: "",
        visitingDate: "",
        isRecording: "",
      },
      currentInHosInfo: {},
      currentInhosPage: 1,
      showVisitingDetail: false,
      showReportDetail: false,
      visitingNoMedicalRecordDetail: {},
      patientMedicalRecord: [],
      inHosTotalPage: 1,
    }
  },
  mixins: [errorHandleMixin],
  computed: {
    ...mapGetters(['patientId']),
    tableHeight() {
      return document.getElementsByClassName('wrap')[0] && document.getElementsByClassName('wrap')[0].offsetHeight - 50
    }
  },
  components: {},
  props: {
    patientData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {
  },
  methods: {
    sexType(type) {
      if (type == 1) {
        return "男"
      } else {
        return "女"
      }
    },
    inHosPageChangeHandler(page) {
      this.currentInhosPage = page
      this.getRecrods()
    },
    // 获取门诊类别
    getVisitingType(state) {
      switch (state) {
        case 0:
          return '门诊'
          break
        case 1:
          return '住院'
          break
        case 2:
          return '体检'
          break
      }
    },
    getRecrods() {
      this.getPatientMedicalRecordAsync().then((res) => {
        this.patientMedicalRecord = res.retValue.map((item) => {
          item.visitingType = this.getVisitingType(item.visitingType)
          item.isContain = item.isContain ? '有' : '无'
          return item
        })
        this.inHosTotalPage = res.totalPage
      })
    },
    // 患者详情--住院信息
    async getPatientMedicalRecordAsync() {
      let request = new RestFeedbackOutControllerGetPatientMedicalRecordNewList()
      request.p_patientId = this.patientId
      request.p_page = this.currentInhosPage
      request.p_departmentName = this.inHosSearch.departmentName
      request.p_visitingType = this.inHosSearch.visitingType
      request.p_visitingDateStart = this.inHosSearch.visitingDate ? moment(this.inHosSearch.visitingDate[0]).format('YYYY-MM-DD HH:mm:ss') : null
      request.p_visitingDateEnd = this.inHosSearch.visitingDate ? moment(this.inHosSearch.visitingDate[1]).format('YYYY-MM-DD HH:mm:ss') : null
      request.p_isRecording = this.inHosSearch.isRecording ? (this.inHosSearch.isRecording == 1 ? true : false) : null
      await request.send()
      return request.result
    },
    searchHandler() {
      this.currentInhosPage = 1
      this.getRecrods()
    },
    getInspectionReportDetailed(item) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestFeedbackOutControllerGetInspectionReportDetailed',
        params: {
          reportId: item.reportId,
        }
      }).then(res => {
        if (res.status == 0) {
          this.inspectionReportDetailed = res.retValue
          this.showReportDetail = true
        } else {

        }
      })
    },
    //出院
    getPatientDischargeRecord(item) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestFeedbackOutControllerGetPatientDischargeRecord',
        params: {
          visitingNo: item.visitingNo,
        }
      }).then(res => {
        if (res.status == 0) {
          this.inspectionReportDetailed = {
            reportType: 3,
            detail: res.retValue
          }
          this.showReportDetail = true
        } else {
        }
      })
    },
    //入院
    getPatientAdmissionRecord(item) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestFeedbackOutControllerGetPatientAdmissionRecord',
        params: {
          visitingNo: item.visitingNo,
        }
      }).then(res => {
        if (res.status == 0) {
          this.inspectionReportDetailed = {
            reportType: 3,
            detail: res.retValue
          }
          this.showReportDetail = true
        } else {
        }
      })
    },
     //手术记录
     getPatientSurgeryTime(item) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestFeedbackOutControllerGetPatientSurgeryRecord',
        params: {
          visitingNo: item.visitingNo,
        }
      }).then(res => {
        if (res.status == 0) {
          this.inspectionReportDetailed  ={
            reportType: 5,
            detail: res.retValue
          }
          this.showReportDetail = true
        } else {
          this.$message.error()
        }
      })
    },
    //手术
    getPatientSurgeryRecord(item) {
      this.inspectionReportDetailed = {
        reportType: 4,
        detail: item.operationRecord
      }
      this.showReportDetail = true
    },
    //获取就诊信息详情
    getVisitingNoMedicalRecordDetail(item) {
      this.currentInHosInfo = item
      this.$store.dispatch('requestHandler', {
        fn: 'RestFeedbackOutControllerGetVisitingNoMedicalRecordDetail',
        params: {
          visitingNo: item.visitingNo,
        }
      }).then(res => {
        if (res.status == 0) {
          this.visitingNoMedicalRecordDetail = res.retValue
          this.showVisitingDetail = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.tableBtn {
  color: #248cfa;
  cursor: pointer;

  &.active {
    color: #c51bc5;
  }
}

.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16),
  0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;

}

.ove {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.trans_box {
  // height: 76vh;
  padding: 5px;
  color: #333333;
  overflow: hidden;
  //position: absolute;
  background-color: white;

  .trans_header {
    width: 100%;
    color: #000;
    //border-bottom: 1px solid #919191;
    //max-height: 25%;
    z-index: 50;

    table {
      width: 100%;

      tr {
        width: 100%;
        line-height: 20px;
        color: #000;

        td {
          font-size: 16px;
        }
      }
    }

    .report-other {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      font-size: 16px;
    }

    .trans_body_header {
      tr {
        display: block;
        border-bottom: 1px solid #919191;
        border-top: 1px solid #919191;
        background-color: white;
        z-index: 65;
      }
    }
  }

  .trans_body {
    width: 100%;
    height: 100%;
    overflow: auto;
    margin-top: 5px;
    z-index: 0;

    .animate {
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 13px;
    }

    div {
      display: flex;

      span {
        padding-left: 15px;
        line-height: 20px;
        word-break: break-all;
        word-wrap: break-word;

        &:first-child {
          text-align: center;
        }
      }

      &:first-child {
        margin-top: 5px;
      }
    }

    .trans_text {
      div {
        width: 100%;
        display: flex;
        margin-bottom: 10px;
        flex-direction: column;

        span {
          &:first-child {
            width: 45%;
            text-align: left;
          }

          &:last-child {
            text-indent: 2em;
            text-align: justify;
            letter-spacing: 0.6px;
          }
        }
      }
    }
  }

  .trans_bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-top: 1px solid #919191;
    background-color: white;

    li {
      min-width: 35%;
      line-height: 20px;
    }
  }
}

.trans_box_two {
  padding: 10px;
  color: #333333;
  overflow: auto;

  .trans_header {
    width: 100%;
    color: #000;
    border-bottom: 1px solid #919191;

    table {
      width: 100%;

      tr {
        width: 100%;
        line-height: 20px;
        color: #000;

        td {
          font-size: 16px;
        }
      }
    }

    .report-other {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .trans_body_header {
      tr {
        padding-bottom: 5px;
        //border-bottom: 1px solid #919191;
        border-top: 1px solid #919191;
        padding-top: 5px;
      }
    }
  }

  .trans_text {
    div {
      width: 100%;
      display: flex;
      margin-bottom: 10px;
      flex-direction: column;

      span {
        line-height: 20px;

        &:first-child {
          width: 45%;
          text-align: left;
        }

        &:last-child {
          //width: 60%;
          text-indent: 2em;
          text-align: justify;
        }
      }
    }
  }

  .trans_bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-top: 1px solid #919191;
    margin-top: 10px;
    background-color: white;

    li {
      min-width: 35%;
      line-height: 20px;
    }
  }

}

.bodyNo {
  width: 8%;
  text-align: center;
}

.bodyItem {
  width: 32%;
  text-align: center;
}

.bodyResult {
  width: 10%;
  text-align: center;
}

.bodyRela {
  width: 40%;
  text-align: center;
}

.bodyUnit {
  width: 10%;
  text-align: center;
}

.reportlist {
  >div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;

  }

  .reportlist-d {
    cursor: pointer;
    width: 70%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;

    >span {
      background-color: #248cfa;
      color: #fff;
      margin: 5px;
      padding: 5px 15px;
      display: inline-block;
      max-width: 200px;
    }
  }
}
</style>
<style lang="scss">
.inspectionReportDetailed {
  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  th,
  td {
    border: 1px solid #ddd !important;
    padding: 8px !important;
  }

  th {
    background-color: #fff !important;
  }
}

.el-select-dropdown,
.el-picker-panel {
  z-index: 9999 !important;
}

.operateClass {
  width: 150px;
}
.el-cascader-panel {
  .el-scrollbar__wrap {
    height: 204px !important;
  }
}

</style>
